<template>
    <div class="super-admin">
        <div class="row" style="padding-bottom: 5px;">
            <div class="col-md-12">
                <div aria-label="project administrators explanation">
                    {{ t_project_administrators_can }}
                </div>
            </div>
        </div>
        <div class="row flex-row">
            <div class="col-md-3 flex-col">
                <div class="form-group flex-group">
                    <label aria-label="set server hosts">
                        {{ t_set_server_hosts }}
                        <select class="form-control" name="configure_mms_hosts" aria-label="configure MMS hosts select">
                            <option value="1">{{ t_yes }}</option>
                            <option value="0">{{ t_no }}</option>
                        </select>
                    </label>
                </div>
            </div>
            <div class="col-md-3 flex-col">
                <div class="form-group flex-group">
                    <label aria-label="set server credentials">
                        {{ t_set_server_credentials }}
                        <select class="form-control" name="configure_mms_credentials" aria-label="configure MMS credentials select">
                            <option value="1">{{ t_yes }}</option>
                            <option value="0">{{ t_no }}</option>
                        </select>
                    </label>
                </div>
            </div>
            <div class="col-md-3 flex-col">
                <div class="form-group flex-group">
                    <label aria-label="set esign host">
                        {{ t_set_esign_host }}
                        <select class="form-control" name="configure_esign_host" aria-label="esign host select">
                            <option value="1">{{ t_yes }}</option>
                            <option value="0">{{ t_no }}</option>
                        </select>
                    </label>
                </div>
            </div>
            <div class="col-md-3 flex-col">
                <div class="form-group flex-group">
                    <label aria-label="set LDAP host">
                        {{ t_set_ldap_host }}
                        <select class="form-control" name="configure_ldap_host" aria-label="configure host select">
                            <option value="1">{{ t_yes }}</option>
                            <option value="0">{{ t_no }}</option>
                        </select>
                    </label>
                </div>
            </div>
        </div>
        <div class="row flex-row">
            <div class="col-md-3 flex-col">
                <div class="form-group flex-group" >
                    <label aria-label="project valid until">
                        {{ t_project_valid_until }}
                        <select
                            v-model="validity_type"
                            class="form-control"
                            aria-label="validity select">
                            <option value="date">{{ t_date }}</option>
                            <option value="hours">{{ t_hours_after_last_use }}</option>
                            <option value="null">{{ t_no_validity_limits }}</option>
                        </select>
                    </label>
                    <template v-if="validity_type === 'date'">
                        <datepicker v-model="validity_date"
                                    popup-used-in-modal />
                    </template>
                    <template v-else-if="validity_type === 'hours'">
                        <div class="input-group">
                            <input type="number"
                                   name="validity-hours"
                                   class="form-control"
                                   v-model="validity_hours"
                                   min="1"
                                   aria-label="validity hours input">
                            <span class="input-group-addon">
                                {{ t_hours }}
                            </span>
                        </div>
                    </template>
                    <input type="hidden"
                           name="validity"
                           class="form-control hidden"
                           v-model="validity"
                           aria-label="validity input">
                </div>
            </div>
            <div class="col-md-3 flex-col">
                <div class="form-group flex-group">
                    <label aria-label="hierarchy">
                        {{ t_hierarchy }}
                        <span :data-balloon="t_hierarchy_description"
                            data-balloon-pos="right"
                            data-balloon-length="large">
                            <i class="fa-light fa-circle-question cursor-pointer"></i>
                        </span>
                        <select class="form-control" name="hierarchy" aria-label="hierarchy select">
                            <option value="1">{{ t_hierarchy_up }}</option>
                            <option value="0">{{ t_hierarchy_down }}</option>
                        </select>
                    </label>
                </div>
            </div>
            <div class="col-md-3 flex-col">
                <div class="form-group flex-group">
                    <label aria-label="MMS folder">
                        {{ t_mms_folder }}
                        <input type="text"
                               name="mms_folder"
                               class="form-control"
                               aria-label="MMS folder input">
                    </label>
                </div>
            </div>
            <div class="col-md-3 flex-col">
                <div class="form-group flex-group">
                    <label aria-label="SA plus hosting">
                        {{ t_saplus_hosting }}
                        <select class="form-control" name="sa_plus" aria-label="SA plus select">
                            <option value="1">{{ t_yes }}</option>
                            <option value="0">{{ t_no }}</option>
                        </select>
                    </label>
                </div>
            </div>
        </div>
        <div class="row flex-row">
            <div class="col-md-12 flex-col">
                <div class="form-group flex-group">
                    <label aria-label="note">
                        {{ t_note }}
                        <input type="text"
                               name="note"
                               class="form-control"
                               aria-label="note input">
                    </label>
                </div>
            </div>
        </div>
        <div class="row flex-row">
            <div class="col-md-4 flex-col">
                <div class="form-group flex-group">
                    <label aria-label="project ID">
                        {{ t_project_id }}
                        <input type="text"
                               name="custom_project_id"
                               class="form-control"
                               v-model="custom_project_id"
                               aria-label="custom project ID input">
                        <input type="hidden"
                               name="custom_project_id_set"
                               v-model="custom_project_id_set"
                               aria-label="custom project ID input">
                    </label>
                </div>
            </div>
            <div class="col-md-2 flex-col">
                <div class="form-group flex-group">
                    <label aria-label="FB import interval">
                        {{ t_fb_import_interval }}
                        <span :data-balloon="t_fb_import_interval_description"
                            data-balloon-pos="right"
                            data-balloon-length="large">
                            <i class="fa-light fa-circle-question cursor-pointer"></i>
                        </span>
                        <input type="text"
                               name="mms_db_importinterval"
                               class="form-control"
                               aria-label="MMS DB import interval input">
                    </label>
                </div>
            </div>
            <div class="col-md-2 flex-col">
                <div class="form-group flex-group">
                    <label aria-label="syslog max rows">
                        {{ t_syslog_max_rows }}
                        <input type="number"
                               name="syslog_max_rows"
                               class="form-control"
                               aria-label="syslog max rows input">
                    </label>
                </div>
            </div>
            <div class="col-md-2 flex-col">
                <div class="form-group flex-group">
                    <label aria-label="HDD quota">
                        {{ t_hdd_quota }}&nbsp;(GB)
                        <input type="text"
                               name="hdd_quota"
                               class="form-control"
                               aria-label="HDD quota input">
                    </label>
                </div>
            </div>
            <div class="col-md-2 flex-col">
                <div class="form-group flex-group">
                    <label aria-label="legacy elements">
                        {{ t_use_legacy_elements }}
                        <select class="form-control" name="use_legacy_elements" v-model="use_legacy_elements" aria-label="legacy elements select">
                            <option :value="1">{{ t_yes }}</option>
                            <option :value="0">{{ t_no }}</option>
                        </select>
                    </label>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-3 flex-col">
                <button type="button" class="btn btn-primary" aria-label="convert demo to regular"
                    v-if="is_demo === 1"
                    @click="convert_demo_to_regular_confirmation">
                    <i class="fa-regular fa-rocket-launch m-r-xs"></i>
                    {{ t_convert_demo_to_regular }}
                    <i class="fa-regular fa-unlock-keyhole m-l-xs"></i>
                </button>
            </div>
        </div>
    </div>
</template>

<script>
    import toaster from "../../common/toaster";

    export default {
        components: {
            datepicker: require('../../common/datepicker.vue').default,
        },
        props: [],
        data: function () {
            return {
                t_project_administrators_can: Lang.langGet("Project Administrators can..."),
                t_set_server_hosts: Lang.langGet("... set the Server/Firebird Hosts"),
                t_set_server_credentials: Lang.langGet("... set the Server/Firebird Credentials"),
                t_set_esign_host: Lang.langGet("... set the esign Host"),
                t_set_ldap_host: Lang.langGet("... set the LDAP Host"),
                t_project_valid_until: Lang.langGet("Project valid until"),
                t_date: Lang.langGet("Date"),
                t_hours_after_last_use: Lang.langChoice("hour|hours", 2) + ' ' + Lang.langGet("after last use"),
                t_no_validity_limits: Lang.langGet("No validity limits"),
                t_hierarchy: Lang.langGet("Hierarchy Direction") + ' (' + Lang.langChoice("Usergroup|Usergroups", 2) + ')',
                t_hierarchy_description: Lang.langGet("Hierarchy upwards: Children see all parents / Hierarchy downwards: Parents see all children"),
                t_hierarchy_up: Lang.langGet("Hierarchy upwards"),
                t_hierarchy_down: Lang.langGet("Hierarchy downwards"),
                t_mms_folder: Lang.langGet("Server folder"),
                t_saplus_hosting: Lang.langGet("SA+ Hosting"),
                t_yes: Lang.langGet("Yes"),
                t_no: Lang.langGet("No"),
                t_note: Lang.langGet("Note"),
                t_project_id: Lang.langGet("Project ID"),
                t_fb_import_interval: Lang.langGet("Firebird Import Interval"),
                t_fb_import_interval_description: Lang.langGet("New data will be imported from the Firebird database every X minutes. This includes POV-Clients and log files."),
                t_syslog_max_rows: Lang.langGet("Syslog max rows"),
                t_hdd_quota: Lang.langGet("HDD Quota"),
                t_use_legacy_elements: Lang.langGet("Use Legacy Elements"),
                t_hours: Lang.langChoice("hour|hours", 2),
                t_convert_demo_to_regular: Lang.langGet("Convert demo project to regular project"),

                id: null,
                validity: '',
                validity_type: '',
                validity_date: null,
                validity_hours: null,
                is_demo: {},
                use_legacy_elements: 0,
                custom_project_id: '',
                custom_project_id_set: false,
            }
        },
        computed: {
        },
        watch: {
            validity: function () {
                this.validityChanged();
            },
            validity_date: function () {
                if (this.validity_type === 'date') {
                    this.validity = this.validity_date;
                }
            },
            validity_hours: function () {
                if (this.validity_type === 'hours') {
                    if (! isNaN(this.validity_hours)) {
                        this.validity = this.validity_hours + ' hours';
                    } else {
                        this.validity = '';
                    }
                }
            },
            validity_type: function () {
                if (this.validity_type === 'hours') {
                    this.validity = this.validity_hours + ' hours';
                } else if (this.validity_type === 'date') {
                    this.validity = this.validity_date ?? '';
                } else {
                    this.validity = null;
                }
            },
            custom_project_id: function () {
                this.custom_project_id_set = this.custom_project_id !== null && this.custom_project_id !== '';
            },
        },
        methods: {
            validityChanged: function() {
                if (this.validity === null) {
                    this.validity_type = 'null';
                } else if (this.validity.includes('hours')) {
                    this.validity_type = 'hours';
                    this.validity_hours = parseInt(this.validity.replace('hours', ''));
                } else if (this.validity !== '') {
                    this.validity_type = 'date';
                    this.validity_date = this.validity;
                }
            },
            convert_demo_to_regular_confirmation: function () {
                let isConfirmed = confirm(Lang.langGet("Are you sure that you want to convert this demo project to a regular project? This step can not be reverted!"));
                if (isConfirmed) {
                    axios.post('project/edit/convert-demo-to-regular', {
                        id: this.id
                    }).then(() => {
                        this.is_demo = false;
                        EaseEventBus.fire('is-demo-changed', false);

                        toaster.success(Lang.langGet("Project successfully converted to a regular project."));
                    }).catch((error) => {
                        if (error.response.status === 401) {
                            window.location = '/login';
                        }

                        toaster.error(Lang.langGet("Something went wrong."));
                    });
                }
            }
        },
        mounted() {
            EaseEventBus.listen('data-super-admin-tab', (data) => {
                this.id = data.id;
                this.validity_date = null;
                this.validity_hours = null;
                if (data.validity?.includes('hours')) {
                    this.validity = data.validity;
                } else {
                    this.validity = data.display_validity;
                }
                this.custom_project_id = data.custom_project_id;
                this.validityChanged();
                this.is_demo = data.is_demo;
                this.use_legacy_elements = data.use_legacy_elements;
                this.adtrac_active = data.adtrac_active;
                this.adtrac_api_endpoint = data.adtrac_api_endpoint;
            });
        }
    }
</script>
